import "babel-polyfill";

import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import VueI18n from "vue-i18n";

import App from "./App.vue";
import store from "./store.js";
import vueRouter from "vue-router";

import SplashPage from "./components/SplashPage";
import Steps from "./components/Steps.vue";
import SystemSetup from "./components/SystemSetup";
import ManualSetup from "./components/ManualSetup";
import ConfirmationPage from "./components/ConfirmationPage";
import VueRouter from "vue-router";

import translations from "./i18n/translation.json";
import dateformats from "./i18n/dateformats.json";
import "./registerServiceWorker";

import VueAppInsights from "vue-application-insights";

import config from "./configuration.json";

Vue.use(vueRouter);

const routes = [
  { path: "/",
    component: SplashPage,
    name: "Splash Page" },
  {
    path: "/steps",
    component: Steps,
    name: "First Steps",
  },
  {
    path: "/manual",
    component: ManualSetup,
    name: "Manual Configurator"
  },
  {
    path: "/system",
    component: SystemSetup,
    name: "System Configurator"
  },
  {
    path: "/confirmation",
    component: ConfirmationPage,
    name: "Confirmation Page"
  },
];

const router = new VueRouter(
  { 
    routes,
    mode: "hash"
  }
);

//Enable online tracking
if (store.getters.onlineTrackingEnabled) {
  Vue.use(VueAppInsights, {
    id: config.appInsightsInstrumentKey,
    trackInitialPageView: false,
    router,
  });
}

Vue.config.productionTip = false;

const dateTimeFormats = dateformats;

// Setup translation service
const i18n = new VueI18n({
  locale: store.getters.language,
  fallbackLocale: "en",
  messages: translations,
  dateTimeFormats,
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
